import { render, staticRenderFns } from "./AllFeeStudents.vue?vue&type=template&id=0bf3e95c"
import script from "./AllFeeStudents.vue?vue&type=script&lang=js"
export * from "./AllFeeStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports